"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Autonumber = function Autonumber() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingRight: "1rem",
      fontSize: "0.875rem",
      marginTop: "0.25rem",
      color: "rgba(156, 163, 175, 1)"
    }
  }, "Automatically incremented unique counter for each record.");
};

var _default = Autonumber;
exports["default"] = _default;